import { Performance, ReturnsByYear } from 'types/performance';

export const getBlankReturnsByYear = (returnsByYear: ReturnsByYear[]): ReturnsByYear[] => {
	const blanks: ReturnsByYear[] = returnsByYear.map((yearReturns) => {
		return {
			year: yearReturns.year,
			returns: {
				returnAsCurrency: '',
				returnAsPercentage: '',
				currentPeriod: false
			}
		};
	});

	return blanks;
};

export const formatPerformanceResponseData = (data: Performance) => {
	if (data?.priorYearReturns?.notReportingNav) {
		const formattedData: ReturnsByYear[] = [];
		const blanks = getBlankReturnsByYear(data.priorYearReturns?.allFunds?.returnsByYear ?? []);

		if (data.priorYearReturns.notReportingNav.reits) {
			data.priorYearReturns.notReportingNav.reits.forEach((reitReturnByYear) => {
				const sliceSize = blanks.length - reitReturnByYear.returnsByYear.length;

				reitReturnByYear.returnsByYear = formattedData.concat(
					blanks.slice(0, sliceSize),
					reitReturnByYear.returnsByYear
				);
			});
		}

		const sliceLength = blanks.length - data.priorYearReturns.notReportingNav.returnsByYear.length;
		data.priorYearReturns.notReportingNav.returnsByYear = formattedData.concat(
			blanks.slice(0, sliceLength),
			data.priorYearReturns.notReportingNav.returnsByYear
		);
	}

	return data;
};
